module.exports = __webpack_public_path__ + "img/logo.802b5050.png";